import { Palette } from '@/themes/themeOverrides/Palette';

export const MuiLinkStyles = {
    styleOverrides: {
        root: {
            color: Palette.black,
            '&:hover': {
                color: `${Palette.black} !important`,
            },
            '& .MuiTypography-root': {
                color: Palette.black,
            },
        },
    },
};
